import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {
  BLUE_LIGHT,
  NEAR_BLACK,
  BLUE_POWDER,
  BLUE_POWDER_LIGHT,
  GRAY_LIGHT,
  GRAY_DARK,
  GRAY_LIGHTER,
  WHITE,
} from 'ui-library/Colors';
import {BasicEvent} from 'util/Types';

export interface CardProps {
  children: JSX.Element;
  onSelect: () => void;
  isDisabled?: boolean;
  selected?: boolean;
  dataTestAttrs?: DataTestAttrs;
  optionsMenu?: JSX.Element;
}

export default function Card(props: CardProps): JSX.Element {
  return (
    <div
      role="button"
      aria-disabled={props.isDisabled}
      tabIndex={0}
      className={classNames(
        css(styles.card, props.isDisabled && styles.disabled, props.selected && styles.selected)
      )}
      onClick={(e: BasicEvent) => {
        if (!props.isDisabled) {
          props.onSelect();
        }
      }}
    >
      <div className={css(styles.children)} {...getTestProps(props.dataTestAttrs)}>
        <div className={css(styles.leftSideOfCard)}>{props.children}</div>
        <div>{props.optionsMenu}</div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: '4px',
    marginBottom: '8px',
    border: `1px solid ${GRAY_LIGHT}`,
    backgroundColor: WHITE,
    userSelect: 'none',
    color: NEAR_BLACK,
    cursor: 'pointer',
    display: 'flex',
    ':hover': {
      backgroundColor: BLUE_POWDER,
      textDecoration: 'none',
    },
  },
  selected: {
    backgroundColor: BLUE_POWDER_LIGHT,
    border: `1px solid ${BLUE_LIGHT}`,
  },
  disabled: {
    color: GRAY_DARK,
    backgroundColot: GRAY_LIGHTER,
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  children: {
    padding: '13px 10px 13px 16px',
    display: 'flex',
    flex: '1',
    lineHeight: '16px',
    justifyContent: 'space-between',
    wordBreak: 'break-all',
  },
  leftSideOfCard: {
    display: 'flex',
  },
});
